"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>CalendarComponent_CalendarComponent
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const date_picker_namespaceObject = require("@pcln/date-picker");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_submitChatMessages_js_namespaceObject = require("../../submitChatMessages.js");
const ChatbotDataContext_js_namespaceObject = require("../../context/ChatbotDataContext.js");
const analytics_js_namespaceObject = require("../../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const format_namespaceObject = require("date-fns/format");
const parse_namespaceObject = require("date-fns/parse");
const differenceInCalendarDays_namespaceObject = require("date-fns/differenceInCalendarDays");
const useChatMessagesContext_js_namespaceObject = require("../../hooks/useChatMessagesContext.js");
const useLoadingStateContext_js_namespaceObject = require("../../hooks/useLoadingStateContext.js");
const useChatUIContext_js_namespaceObject = require("../../hooks/useChatUIContext.js");
const CalendarComponent = ({ markerComponentProps, isLastMessage })=>{
    const [resolvedStartDate, setResolvedStartDate] = (0, external_react_namespaceObject.useState)('');
    const [resolvedEndDate, setResolvedEndDate] = (0, external_react_namespaceObject.useState)('');
    const [numberOfNights, setNumberOfNights] = (0, external_react_namespaceObject.useState)(0);
    const { submitChatMessagesPayload, handleMarkerResponse, fetchRequestOptions, markerComponents, setErrorMessage, setStreamingText, setIsDisablingInputValue, isMobile } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const { setLoadingStatus, setLoadingStatusMessage } = (0, useLoadingStateContext_js_namespaceObject.useLoadingStateContext)();
    const { setOpenErrorComponent } = (0, useChatUIContext_js_namespaceObject.useChatUIContext)();
    const { chatMessages, setChatMessages } = (0, useChatMessagesContext_js_namespaceObject.useChatMessagesContext)();
    const submitChatMessagesOptions = {
        setChatMessages,
        setStreamingText,
        setLoadingStatus,
        setLoadingStatusMessage,
        setErrorMessage,
        setIsDisablingInputValue,
        requestOptions: fetchRequestOptions,
        markerComponents,
        handleMarkerResponse
    };
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (resolvedStartDate && resolvedEndDate) {
            let nightsText = '';
            if (numberOfNights && numberOfNights > 1) nightsText = ` (${numberOfNights} nights)`;
            else if (numberOfNights && 1 === numberOfNights) nightsText = ` (${numberOfNights} night)`;
            const chatContent = `Search for hotels with Check-in date - ${resolvedStartDate} and check-out date - ${resolvedEndDate}${nightsText}.`;
            const chatMessage = {
                content: chatContent,
                date: new Date(),
                role: 'user'
            };
            const promptMessage = {
                content: chatContent,
                role: 'user'
            };
            chatMessages.pop();
            const updatedChatMessages = [
                ...chatMessages,
                chatMessage
            ];
            setChatMessages(updatedChatMessages);
            (0, external_submitChatMessages_js_namespaceObject.submitChatMessages)({
                submitChatMessagesPayload: {
                    ...submitChatMessagesPayload,
                    prompts: [
                        promptMessage
                    ]
                },
                setOpenErrorComponent,
                chatMessages: updatedChatMessages,
                ...submitChatMessagesOptions
            }).catch((e)=>{
                analytics_js_default().log({
                    message: e?.message,
                    source: 'CalendarComponent'
                });
            });
        }
    }, [
        resolvedEndDate,
        resolvedStartDate
    ]);
    const calculateNights = (startDate, endDate)=>{
        if (startDate && endDate) {
            const start = new Date(parseInt(startDate.substring(0, 4), 10), parseInt(startDate.substring(4, 6), 10) - 1, parseInt(startDate.substring(6, 8), 10));
            const end = new Date(parseInt(endDate.substring(0, 4), 10), parseInt(endDate.substring(4, 6), 10) - 1, parseInt(endDate.substring(6, 8), 10));
            return (0, differenceInCalendarDays_namespaceObject.differenceInCalendarDays)(end, start);
        }
        return 0;
    };
    function handleSelectedDates(e, f) {
        if (e && f) {
            if (f?.startDate && f?.endDate) {
                setNumberOfNights(calculateNights(f.startDate, f.endDate));
                const parsedStartDate = (0, parse_namespaceObject.parse)(f.startDate, 'yyyyMMdd', new Date());
                const parsedEndDate = (0, parse_namespaceObject.parse)(f.endDate, 'yyyyMMdd', new Date());
                setResolvedStartDate((0, format_namespaceObject.format)(parsedStartDate, 'EEEE, MMMM dd, yyyy'));
                setResolvedEndDate((0, format_namespaceObject.format)(parsedEndDate, 'EEEE, MMMM dd, yyyy'));
            }
        }
    }
    function handleCalenderRef(ref) {
        ref.style.position = 'relative';
        ref.style.marginLeft = '30px';
        ref.scrollIntoView?.({
            behavior: 'smooth'
        });
    }
    if (!isLastMessage) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
        mb: 2,
        maxHeight: isMobile ? '300px' : null,
        overflowY: 'auto',
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(date_picker_namespaceObject.Calendar, {
            monthsToShow: 1,
            isMobile: isMobile,
            monthWidthPx: 300,
            onChange: handleSelectedDates,
            setCalendarRef: handleCalenderRef,
            calendarWrapperStyles: {
                boxShadow: 'lg'
            }
        })
    });
};
const CalendarComponent_CalendarComponent = CalendarComponent;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
